export default {
    settings: 'settings',
    botAdmin: 'botAdmin',
    messageDrawer: 'messageDrawer',
    notificationExample: 'notificationExample',
    mobileDrawer: 'mobileDrawer',
    contact: 'contact',
};
